import { useMemo, type ReactNode } from 'react';
import { UnreadTextCountStoreContext } from './lib/unreadTextCountContext';
import { createUnreadTextCountStore } from './lib/unreadTextCountStore';

/**
 * App-lifetime provider for the team-wide unread text-conversation count.
 *
 * Renders nothing of its own -- only `children` -- so it never re-renders on a
 * count change. The count itself lives in a subscription store
 * (`unreadTextCountStore`), reached through `useUnreadTextCount()`, and
 * `UnreadTextCountHost` is its only writer.
 */
const UnreadTextCountProvider = ({ children }: { children: ReactNode }) => {
  const store = useMemo(createUnreadTextCountStore, []);

  return (
    <UnreadTextCountStoreContext.Provider value={store}>
      {children}
    </UnreadTextCountStoreContext.Provider>
  );
};

export default UnreadTextCountProvider;
